import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@material-ui/core";
import dayjs from "dayjs";
import Link from "../../components/Link";
import { formatDollars } from "./utils";

export default function TopPartnersTable({ topPartners, selectedMonth, loading, classes }) {
  return (
    <Paper className={classes.chartSection}>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell colSpan={5}>
                <Typography variant="h6">
                  Top Partners — {dayjs(selectedMonth).format("MMM YYYY")}
                </Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Partner</TableCell>
              <TableCell align="center">SDK</TableCell>
              <TableCell align="right">Ongoing Rate</TableCell>
              <TableCell align="right">Charge Count</TableCell>
              <TableCell align="right">Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={5}>Loading...</TableCell>
              </TableRow>
            ) : topPartners.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5}>No partner data for this month.</TableCell>
              </TableRow>
            ) : (
              topPartners.map((partner) => (
                <TableRow key={partner.partnerId}>
                  <TableCell>
                    <Link to={`/partners/${partner.partnerId}`}>
                      {partner.partnerName}
                    </Link>
                  </TableCell>
                  <TableCell align="center">
                    {partner.isSdk ? "Yes" : "No"}
                  </TableCell>
                  <TableCell align="right">
                    ${formatDollars(partner.ongoingRateCents)}
                  </TableCell>
                  <TableCell align="right">
                    {partner.chargeCount}
                  </TableCell>
                  <TableCell align="right">
                    ${partner.totalDollars || formatDollars(partner.totalCents)}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
